import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const SurveyStep = ({ question, onSubmit, currentStep, totalSteps, onBack }) => {
  // Per domande a testo
  const [textResponse, setTextResponse] = useState('');
  
  // Per domande a scelta multipla
  const [selectedOptions, setSelectedOptions] = useState([]);
  
  const [error, setError] = useState('');

  // Reset delle risposte quando cambia domanda
  useEffect(() => {
    setTextResponse('');
    setSelectedOptions([]);
    setError('');
  }, [question]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    /*
    if (question.type === 'text' && !textResponse) {
      setError('Per favore inserisci una risposta');
      return;
    }
    */
    
    if (question.type !== 'text' && selectedOptions.length === 0) {
      setError('Per favore seleziona almeno una risposta');
      return;
    }
    
    // Invia il tipo di risposta appropriato
    if (question.type === 'text') {
      onSubmit({ text_answer: textResponse });
    } else {
      onSubmit({ selected_option_ids: selectedOptions });
    }
  };
  
  // Gestione checkbox per domande con risposta multipla
  const handleCheckboxChange = (optionId) => {
    const optionIdStr = optionId.toString();
    
    if (selectedOptions.includes(optionIdStr)) {
      // Rimuovi l'opzione se già selezionata
      setSelectedOptions(selectedOptions.filter(id => id !== optionIdStr));
    } else {
      // Aggiungi l'opzione se non è già selezionata
      setSelectedOptions([...selectedOptions, optionIdStr]);
    }
  };
  
  // Gestione radio per domande con singola risposta
  const handleRadioChange = (optionId) => {
    setSelectedOptions([optionId.toString()]);
  };

  // Gestione del cambio di testo con limite di caratteri
  const handleTextChange = (e) => {
    const text = e.target.value;
    // Limita il testo a 500 caratteri
    if (text.length <= 600) {
      setTextResponse(text);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <h2 className="text-2xl font-bold mb-4">{question.title}</h2>
        <p className="mb-4">{question.description}</p>
        
        {error && (
          <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-md">
            {error}
          </div>
        )}
        
        {question.type === 'text' ? (
          <div className="mb-4">
            <textarea
              value={textResponse}
              onChange={handleTextChange}
              className="w-full p-3 border border-gray-300 rounded focus:ring-2 focus:ring-purple-500 focus:border-transparent"
              placeholder="Scrivi la tua risposta qui..."
              rows={10}
              maxLength={600}
            />
            <div className="flex justify-between mt-1 text-sm text-gray-500">
              <span>Max 600 caratteri</span>
              <span>{textResponse.length}/600</span>
            </div>
          </div>
        ) : (
          question.options.map(option => (
            <div key={option.id} className="mb-4">
              <label className="flex items-center">
                <input
                  type={question.allows_multiple ? "checkbox" : "radio"}
                  name="option"
                  value={option.id}
                  checked={selectedOptions.includes(option.id.toString())}
                  onChange={() => 
                    question.allows_multiple 
                      ? handleCheckboxChange(option.id) 
                      : handleRadioChange(option.id)
                  }
                  className="mr-2"
                />
                {option.description}
              </label>
            </div>
          ))
        )}
        
        {/* Area di input testo aggiuntiva se la domanda lo richiede */}
        {question.has_text_input && question.type !== 'text' && (
          <div className="mt-4">
            <label className="block mb-2">Commenti aggiuntivi:</label>
            <textarea
              value={textResponse}
              onChange={handleTextChange}
              className="w-full p-3 border border-gray-300 rounded focus:ring-2 focus:ring-purple-500 focus:border-transparent"
              placeholder="Inserisci eventuali commenti..."
              rows={3}
              maxLength={600}
            />
            <div className="flex justify-between mt-1 text-sm text-gray-500">
              <span>Max 600 caratteri</span>
              <span>{textResponse.length}/600</span>
            </div>
          </div>
        )}
        
        <button
          type="submit"
          className="w-full bg-orange-500 text-white py-3 rounded-md hover:bg-orange-600 mb-6"
        >
          Conferma Risposta
        </button>
      </form>
      
      <div className="w-full p-4 mt-4 bg-white">
        <div className="flex justify-between mx-auto w-full">
          <button
            onClick={onBack}
            disabled={currentStep === 0}
            className={`px-4 py-2 rounded-full border font-semibold transition duration-150 ease-in-out ${
              currentStep === 0
                ? 'bg-gray-200 text-gray-400 border-gray-200 cursor-not-allowed'
                : 'bg-white text-orange-500 border-orange-500 hover:bg-orange-100'
            }`}
          >
            Indietro
          </button>
          <div className="text-gray-500">
            Step {currentStep + 1} di {totalSteps}
          </div>
        </div>
      </div>
    </div>
  );
};

SurveyStep.propTypes = {
  question: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  onBack: PropTypes.func.isRequired
};

export default SurveyStep;